import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from "ionic-angular";
import {MsgManager} from "../../providers/msg-manager";
import {DatePickerProvider} from "ionic2-date-picker";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {ApiOffline} from "../../providers/api-offline";
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-trendingproducts',
  templateUrl: 'trendingproducts.html',
})
export class TrendingproductsPage {

  private startDate: any;
  private endDate:any;
  private orderStatus: any;
  private byBookmarks: any;
  private totoaBookmarks: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public api: Api, private cartManager: CartManager,
              public alertCtrl: AlertController,
              public msgManager:MsgManager,
              private gVLogger:GVLogger,
              private apiOffline:ApiOffline,
              private modalCtrl:ModalController,
              private datePickerProvider:DatePickerProvider) {

    let year = new Date().getFullYear();
    this.startDate = year + "-01-01";
    let month = '';
    let day = '';
    let mm: any = new Date().getMonth()+1;
    let dd: any = new Date().getDate();

    if (dd > 0 && dd < 10) {
      dd = "0" + dd;
    }
    if (mm > 0 && mm < 10) {
      mm = "0" + mm;
    }
    this.endDate = new Date().getFullYear() + "-" + mm + "-" + dd;

    this.ByBookmarks();




  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad TrendingproductsPage');
  }

  showCalendarEnd(){

    const dateSelected =  this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date(""+date);
      let dd:any = d.getDate();
      if( dd>0 && dd<10){
        dd = "0"+dd;
      }
      let mm:any = d.getMonth()+1; //January is 0!
      if( mm>0 && mm<10){
        mm = "0"+mm;
      }
      var output = d.getFullYear() +"-"+  mm + "-" + dd;
      this.endDate = output;
    });
  }

  showCalendarStart(){

    const dateSelected =  this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date(""+date);
      let dd:any = d.getDate();
      if( dd>0 && dd<10){
        dd = "0"+dd;
      }
      let mm:any = d.getMonth()+1; //January is 0!
      if( mm>0 && mm<10){
        mm = "0"+mm;
      }
      var output = d.getFullYear() +"-"+  mm + "-" + dd;
      this.startDate = output;

    });
  }


  ByBookmarks(){
    let body = {
      startDate: new Date(this.startDate),
      endDate: new Date(this.endDate)
    };
    //this.gVLogger.log("Download template clicked");
    this.api.postlocal("reports/app/potentialaccounts/bybookmarks", body)
      .subscribe(res=>{
        this.byBookmarks = res.json();
        this.totoaBookmarks = this.byBookmarks.length;
      },err=>{

      });
  }

  shipDateChanged() {
   this.ByBookmarks();
  }

}



// WEBPACK FOOTER //
// ./src/pages/trendingproducts/trendingproducts.ts